angular.module("admin").factory("AdminCreditsService", ["$http", "ENV", function ($http, ENV) {

	/**
	 * API
	 */
	return {
		dashboardAdmin: dashboardAdmin
	};

	function dashboardAdmin() {
		return $http.get(ENV.API_URL + "/admin/credits/dashboard/admin");
	}

}]);
